module.exports = __webpack_public_path__ + "static/img/capitania_menor.a0dae09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/capitania_menor.png
// module id = 0f0X
// module chunks = 0